import { render, staticRenderFns } from "./FRONXBOOSTERGREENGLX.vue?vue&type=template&id=fa977a02&"
import script from "./FRONXBOOSTERGREENGLX.vue?vue&type=script&lang=ts&"
export * from "./FRONXBOOSTERGREENGLX.vue?vue&type=script&lang=ts&"
import style0 from "./FRONXBOOSTERGREENGLX.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports